const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

/* NuHer fix: when a visitor presses Back, the browser restores the page exactly as it was left,
   including the theme's fade-out on #MainContent. Fade the page back in whenever it is shown. */
(function () {
  function nuherReveal() {
    var els = [document.getElementById('MainContent'), document.querySelector('.footer-group'), document.getElementById('shopify-section-footer-group')];
    els.forEach(function (el) {
      if (!el) return;
      el.classList.remove('page-transition');
      el.classList.add('page-loaded');
    });
  }
  window.addEventListener('pageshow', nuherReveal);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') nuherReveal();
  });
})();
